module.exports = __webpack_public_path__ + "img/deleted_red.32c8b64a.svg";